import Cookies from "js-cookie";

export function getCookie (name) {
    let cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      let parts = cookies[i].split('=');
      if (parts[0] === name) {
        return parts[1];
      }
    }
    return '';
}
export function setCookie (name, value, days) {
    Cookies.set(name, value, { expires: days });
}